import fecha from 'fecha';
export var formatDate = function (date, toFormat, i18n) {
  if (toFormat === void 0) {
    toFormat = 'DD/MM/YYYY';
  }
  return fecha.format(date, toFormat, i18n);
};